// removed by extract-text-webpack-plugin
module.exports = {"Wrap":"_38cLy0zSM8KSKgN6VaDVt9","Opened":"_18-DHdkdRvaZa70POjJP8F","Submenu":"UZTAhSksCEDa8zh5hN8sk"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Utils/ContextMenu/styles.module.css
// module id = 585
// module chunks = 0